module.exports = __webpack_public_path__ + "img/shield-warning.11b5cac9.svg";